<template>
  <div class="row">
    <!-- Course Grid -->
    <div class="col-xxl-4 col-md-6 d-flex" v-for="course in courses" :key="course.id">
      <div class="course-box flex-fill">
        <div class="product">
          <div class="product-img">
            <router-link :to="'/' + course.slug">
              <img v-if="course.coverImage"
                :src="course.coverImage"
                class="img-fluid"
                alt="Img"
                
              />
              <img v-if="!course.coverImage"
                class="img-fluid"
                alt="Img"
                src="@/assets/img/course/course-02.jpg"
              />
            </router-link>
            <div class="price">
              <h3>R$ {{ course.basePrice }} <span>R$ {{ (course.basePrice*1.5).toFixed(0) }}</span></h3>
            </div>
          </div>
          <div class="product-content">
            <h3 class="title instructor-text">
              <router-link  :to="'/' + course.slug"
                >{{course.title}}</router-link
              >
            </h3>
            <div class="course-info d-flex align-items-center">
              <div class="rating-img d-flex align-items-center">
                <img src="@/assets/img/icon/icon-01.svg" alt="Img" />
                <p>{{course.lessonsCount}} + Aulas</p>
              </div>
              <!-- <div class="course-view d-flex align-items-center">
                <img src="@/assets/img/icon/icon-02.svg" alt="Img" />
                <p>70hr 30min</p>
              </div> -->
            </div>
            <div
              class="course-edit-btn d-flex align-items-center justify-content-between"
            >
            <router-link :to="'/caduceus/courses/edit/' + course.id"><i class="bx bx-edit me-2"></i>Editar</router-link>
              <a href="#"><i class="bx bx-trash me-2"></i>Deletar</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Course Grid -->

    <!-- /Course Grid -->
  </div>
</template>
<script setup>
// Recebendo as props diretamente no script setup
defineProps({
  courses: {
    type: Array,
    required: true
  }
});
</script>